"use client";

import { ContentComponent } from "@/types/modules";
import Content from "../Content";
import Featured from "../Featured";
import ViewAll from "../ViewAll";
import { LanguageContext } from "@/context/languageContext";
import { useContext, useEffect } from "react";
import { Event } from "@/types/wordpress";
import { translate } from "@/utils/translate";
import { useLanguageUrl } from "@/context/languageURLContext";

interface EventComponentProps {
  event: Event;
}

export default function EventComponent({ event }: EventComponentProps) {
  const { language } = useContext(LanguageContext);

  const { url, setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(event.translations[0].uri);
  }, [event.translations, setUrl]);

  const content: ContentComponent = {
    imageAlign: event.contentFields.imageAlign,
    textAlign: event.contentFields.textAlign,
    content: event.contentFields.body,
    gallery: event.contentFields.gallery,
    sameWidth: true,
    ...(event.contentFields.button
      ? {
          button: event.contentFields.button,
        }
      : {
          buttonEvents: {
            text: translate["enquireNow"][language],
          },
        }),
    ...(event.contentFields.title && {
      title: event.contentFields.title,
    }),
  };

  return (
    <>
      <section className="content">
        <div className="contentContainer contentEvents">
          <Content content={content} />
        </div>
      </section>
      <ViewAll
        text={translate["viewAllEvents"][language]}
        link={`/${language}/events`}
      />
      <Featured featured={event.featured} />
    </>
  );
}
